import { useState } from 'react'
import api from '../../api/axios'

const STEPS = ['Conexão', 'Selecionar Leilão', 'Revisar Lotes', 'Importar']

const FLUXO_OPTIONS = [
  { value: 'comissao_separada', label: 'Comissão Separada' },
  { value: 'separada',          label: 'Comissão Separada (legado)' },
  { value: 'primeira_parcela',  label: 'Comissão na Primeira Parcela' },
  { value: 'gta_nota',          label: 'GTA + Nota' },
  { value: 'parcelada',         label: 'Comissão Parcelada' },
]

const FLUXO_LABEL = {
  comissao_separada: 'Comissão Separada',
  separada:          'Comissão Separada',
  primeira_parcela:  'Comissão na Primeira Parcela',
  gta_nota:          'GTA + Nota',
  parcelada:         'Comissão Parcelada',
}

const brl = (v) => Number(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })

export default function ImportacaoLeilao() {
  const [step, setStep] = useState(0)
  const [loading, setLoading] = useState(false)
  const [erro, setErro] = useState('')

  // Passo 0
  const [creds, setCreds] = useState({ email: '', password: '' })

  // Passo 1
  const [leiloes, setLeiloes] = useState([])
  const [historico, setHistorico] = useState([]) // [{id_antigo, nome_antigo, org_name, data_importacao}]

  // Passo 2
  const [leilaoSelecionado, setLeilaoSelecionado] = useState(null)
  const [preview, setPreview] = useState(null)

  // Passo 3 — organizer
  const [organizadores, setOrganizadores] = useState([])
  const [orgSelecionada, setOrgSelecionada] = useState(null)
  const [comissoes, setComissoes] = useState([])
  const [fluxo, setFluxo] = useState('')
  const [comissaoPadraoId, setComissaoPadraoId] = useState('')
  const [loadingOrg, setLoadingOrg] = useState(false)

  // Passo 3 — leiloeiro
  const [leiloeiros, setLeiloeiros] = useState([])
  const [leiloeiroId, setLeiloeiroId] = useState('')
  const [novoLeiloeiroNome, setNovoLeiloeiroNome] = useState('')
  const [loadingLeiloeiro, setLoadingLeiloeiro] = useState(false)
  const [leiloeiroCriado, setLeiloeiroCriado] = useState(false)

  // Passo 3 — criar/selecionar leilão
  const [leilioesDaOrg, setLeilioesDaOrg] = useState([])
  const [modoLeilao, setModoLeilao] = useState('selecionar') // 'selecionar' | 'criar'
  const [novoNome, setNovoNome] = useState('')
  const [novoData, setNovoData] = useState('')
  const [novoHora, setNovoHora] = useState('08:00')
  const [novoCidade, setNovoCidade] = useState('')
  const [novoUf, setNovoUf] = useState('')
  const [leilaoIdNovo, setLeilaoIdNovo] = useState('')
  const [leilaoCriado, setLeilaoCriado] = useState(null)
  const [loadingCriar, setLoadingCriar] = useState(false)

  // Resultado importação
  const [resultado, setResultado] = useState(null)
  const [dryRun, setDryRun] = useState(true)
  const [clientesCriando, setClientesCriando] = useState({}) // nome → 'loading'|'ok'|'erro'

  // Job background (importação real)
  const [jobId, setJobId] = useState(null)
  const [jobFase, setJobFase] = useState(null)
  const [jobFaseLabel, setJobFaseLabel] = useState('')

  // Migrar despesas (retroativo)
  const [migrandoDespesas, setMigrandoDespesas] = useState({}) // leilao_id_antigo → 'loading'|resultado


  // ── Passo 0 → buscar leilões ──────────────────────────────────────────────
  const handleBuscarLeiloes = async () => {
    setErro('')
    setLoading(true)
    try {
      const [resLeiloes, resHist] = await Promise.all([
        api.post('/super-admin/importacao/buscar-leiloes', creds),
        api.get(`/super-admin/importacao/historico?email_sistema_antigo=${encodeURIComponent(creds.email)}`),
      ])
      setLeiloes(resLeiloes.data.leiloes)
      setHistorico(resHist.data)
      setStep(1)
    } catch (e) {
      setErro(e.response?.data?.detail || 'Erro ao conectar')
    } finally {
      setLoading(false)
    }
  }

  // ── Passo 1 → preview dos lotes ───────────────────────────────────────────
  const handlePreview = async (leilao) => {
    setErro('')
    setLeilaoSelecionado(leilao)
    setLoading(true)
    try {
      const { data } = await api.post('/super-admin/importacao/preview-lotes', {
        ...creds,
        leilao_id_antigo: leilao.id,
      }, { timeout: 120000 })
      setPreview(data)
      setStep(2)
    } catch (e) {
      setErro(e.response?.data?.detail || 'Erro ao buscar lotes')
    } finally {
      setLoading(false)
    }
  }

  // ── Passo 2 → entrar em configurar destino ────────────────────────────────
  const handleAvancarDestino = async () => {
    setResultado(null)
    setErro('')
    setLoading(true)
    try {
      const { data } = await api.get('/organizadores?per_page=100&status=ativo')
      setOrganizadores(data.data || [])
    } catch (e) {
      setErro(e.response?.data?.detail || 'Erro ao carregar organizadores')
      setLoading(false)
      return
    } finally {
      setLoading(false)
    }
    // Pre-fill com dados extraídos do sistema antigo
    setNovoNome(leilaoSelecionado?.nome || '')
    setNovoData(preview?.data_leilao || '')
    setNovoHora(preview?.hora_inicio || '08:00')
    setNovoCidade(preview?.cidade || '')
    setNovoUf(preview?.uf || '')
    setLeilaoIdNovo('')
    setLeilaoCriado(null)
    setOrgSelecionada(null)
    setComissoes([])
    setFluxo('')
    setComissaoPadraoId('')
    setStep(3)
  }

  // ── Passo 3 → selecionar organizador ─────────────────────────────────────
  const handleSelecionarOrg = async (org) => {
    setOrgSelecionada(org)
    setFluxo(org.fluxo_leilao || 'primeira_parcela')
    setComissoes([])
    setComissaoPadraoId('')
    setLeilaoIdNovo('')
    setLeilaoCriado(null)
    setLeiloeiros([])
    setLeiloeiroId('')
    setNovoLeiloeiroNome(preview?.nome_leiloeiro || '')
    setLeiloeiroCriado(false)
    setLeilioesDaOrg([])
    setLeilaoIdNovo('')
    setLeilaoCriado(null)
    setModoLeilao('selecionar')
    setLoadingOrg(true)
    try {
      const [resComissoes, resLeiloeiros, resLeiloes] = await Promise.all([
        api.get(`/organizadores/${org.id}/comissoes`),
        api.get(`/organizadores/${org.id}/leiloeiros`),
        api.get(`/organizadores/${org.id}/leiloes`),
      ])

      // Comissões — tenta casar com o combo mais usado no preview
      const comissoesData = resComissoes.data
      setComissoes(comissoesData)
      const mainComboKey = Object.entries(preview?.combinacoes_comissao || {})
        .sort((a, b) => b[1] - a[1])[0]?.[0] || ''
      const mCombo = mainComboKey.match(/V:([\d.]+)%\s*\/\s*C:([\d.]+)%/)
      let matched = null
      if (mCombo) {
        const [, v, c] = mCombo
        matched = comissoesData.find(cm =>
          Math.abs(parseFloat(cm.comissao_venda) - parseFloat(v)) < 0.01 &&
          Math.abs(parseFloat(cm.comissao_compra) - parseFloat(c)) < 0.01
        )
      }
      setComissaoPadraoId(String(matched?.id || comissoesData.find(c => c.is_padrao)?.id || ''))

      // Leilões da org
      setLeilioesDaOrg(resLeiloes.data || [])

      // Leiloeiros — tenta casar pelo nome do sistema antigo
      const leiloeiroData = resLeiloeiros.data
      setLeiloeiros(leiloeiroData)
      const nomeAntigo = (preview?.nome_leiloeiro || '').toUpperCase().trim()
      if (nomeAntigo) {
        const match = leiloeiroData.find(l =>
          l.nome.toUpperCase().includes(nomeAntigo) || nomeAntigo.includes(l.nome.toUpperCase())
        )
        if (match) setLeiloeiroId(String(match.id))
      }
    } catch (e) {
      setErro('Erro ao carregar dados do organizador')
    } finally {
      setLoadingOrg(false)
    }
  }

  // ── Passo 3 → criar leiloeiro ─────────────────────────────────────────────
  const handleCriarLeiloeiro = async () => {
    if (!novoLeiloeiroNome.trim()) return
    setLoadingLeiloeiro(true)
    setErro('')
    try {
      const { data } = await api.post(`/organizadores/${orgSelecionada.id}/leiloeiros`, {
        nome: novoLeiloeiroNome.trim(),
      })
      setLeiloeiros(prev => [...prev, data])
      setLeiloeiroId(String(data.id))
      setLeiloeiroCriado(true)
    } catch (e) {
      setErro(e.response?.data?.detail || 'Erro ao criar leiloeiro')
    } finally {
      setLoadingLeiloeiro(false)
    }
  }

  // ── Passo 3 → criar leilão ────────────────────────────────────────────────
  // comissao_separada não existe no enum do backend — mapeia para 'separada'
  const normalizeFluxo = (f) => f === 'comissao_separada' ? 'separada' : f

  const handleCriarLeilao = async () => {
    if (!orgSelecionada || !novoNome || !novoData || !fluxo || !novoCidade || !novoUf) {
      setErro('Preencha nome, data, hora, cidade, UF e fluxo antes de criar o leilão')
      return
    }
    setErro('')
    setLoadingCriar(true)
    try {
      const { data } = await api.post(`/organizadores/${orgSelecionada.id}/leiloes`, {
        nome: novoNome,
        data_leilao: `${novoData}T12:00:00`,
        hora_inicio: novoHora,
        cidade: novoCidade,
        uf: novoUf.toUpperCase(),
        tipo_leilao: 'gado_corte',
        fluxo_comissao: normalizeFluxo(fluxo),
        comissao_padrao_id: comissaoPadraoId ? parseInt(comissaoPadraoId) : null,
        leiloeiro_id: leiloeiroId ? parseInt(leiloeiroId) : null,
      })
      setLeilaoCriado(data)
      setLeilaoIdNovo(String(data.id))
    } catch (e) {
      setErro(e.response?.data?.detail || 'Erro ao criar leilão')
    } finally {
      setLoadingCriar(false)
    }
  }

  // ── Parseia nomes de clientes faltantes dos erros do dry-run ─────────────
  const clientesFaltantes = (() => {
    if (!resultado?.erros?.length) return []
    const nomes = new Set()
    resultado.erros.forEach(e => {
      const m = e.match(/(?:vendedor|comprador) '(.+?)' não encontrado/)
      if (m) nomes.add(m[1])
    })
    return [...nomes]
  })()

  // ── Criar cliente faltante ────────────────────────────────────────────────
  const handleCriarCliente = async (nome) => {
    setClientesCriando(prev => ({ ...prev, [nome]: 'loading' }))
    try {
      await api.post(`/organizadores/${orgSelecionada.id}/clientes`, { nome, organizador_id: orgSelecionada.id })
      setClientesCriando(prev => ({ ...prev, [nome]: 'ok' }))
    } catch (e) {
      setClientesCriando(prev => ({ ...prev, [nome]: 'erro' }))
    }
  }

  const handleCriarTodosClientes = async () => {
    for (const nome of clientesFaltantes) {
      if (clientesCriando[nome] === 'ok') continue
      await handleCriarCliente(nome)
    }
  }

  // ── Migrar despesas retroativamente (a partir do histórico) ──────────────
  const handleMigrarDespesas = async (reg) => {
    setMigrandoDespesas(prev => ({ ...prev, [reg.leilao_id_antigo]: 'loading' }))
    try {
      const { data } = await api.post('/super-admin/importacao/importar-despesas', {
        ...creds,
        leilao_id_antigo: reg.leilao_id_antigo,
        leilao_id_novo: reg.leilao_id_novo,
        org_id: reg.org_id,
      }, { timeout: 600000 })
      setMigrandoDespesas(prev => ({ ...prev, [reg.leilao_id_antigo]: data }))
    } catch (e) {
      setMigrandoDespesas(prev => ({
        ...prev,
        [reg.leilao_id_antigo]: { erro: e.response?.data?.detail || 'Erro ao migrar despesas' },
      }))
    }
  }

  // ── Passo 3 → executar importação ────────────────────────────────────────
  const handleExecutar = async (isDryRun) => {
    if (!orgSelecionada || !leilaoIdNovo) {
      setErro('Selecione o organizador e um leilão destino')
      return
    }
    setDryRun(isDryRun)
    setErro('')
    setClientesCriando({})
    setResultado(null)
    setJobId(null)
    setJobFase(null)
    setJobFaseLabel('')
    setLoading(true)

    try {
      const { data } = await api.post('/super-admin/importacao/executar', {
        ...creds,
        leilao_id_antigo: leilaoSelecionado.id,
        leilao_id_novo: parseInt(leilaoIdNovo),
        org_id: orgSelecionada.id,
        dry_run: isDryRun,
      }, { timeout: 180000 })

      // dry_run retorna resultado direto (síncrono)
      if (isDryRun) {
        setResultado(data)
        setLoading(false)
        return
      }

      // Importação real — polling do job em background
      const id = data.job_id
      setJobId(id)

      const poll = async () => {
        try {
          const { data: job } = await api.get(`/super-admin/importacao/status-leiloes-bulk/${id}`)
          setJobFase(job.fase)
          setJobFaseLabel(job.fase_label || '')

          if (job.status === 'concluido') {
            const res = {
              importados: job.importados || 0,
              erros: job.erros || [],
              leilao_nome: job.leilao_nome || '',
              total_scraped: job.total_scraped || 0,
            }
            setResultado(res)
            setLoading(false)

            if (res.importados > 0) {
              await api.post('/super-admin/importacao/historico', {
                email_sistema_antigo: creds.email,
                leilao_id_antigo: leilaoSelecionado.id,
                leilao_nome_antigo: leilaoSelecionado.nome,
                leilao_id_novo: parseInt(leilaoIdNovo),
                org_id: orgSelecionada.id,
                org_name: orgSelecionada.name,
                importados: res.importados,
                erros: res.erros,
              })
              const resHist = await api.get(`/super-admin/importacao/historico?email_sistema_antigo=${encodeURIComponent(creds.email)}`)
              setHistorico(resHist.data)
              setTimeout(() => { setResultado(null); setStep(1) }, 2000)
            }
          } else if (job.status === 'erro') {
            setErro(job.erro_global || 'Erro na importação')
            setLoading(false)
          } else {
            setTimeout(poll, 2500)
          }
        } catch {
          setTimeout(poll, 3000)
        }
      }
      poll()

    } catch (e) {
      setErro(e.response?.data?.detail || 'Erro na importação')
      setLoading(false)
    }
  }

  // ── Render ────────────────────────────────────────────────────────────────
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-800 mb-2">Importação de Leilão</h1>
      <p className="text-sm text-gray-500 mb-6">Exclusivo SuperAdmin — importa lotes do sistema antigo (app.rematei.com.br)</p>

      {/* Stepper */}
      <div className="flex items-center mb-8 gap-2">
        {STEPS.map((s, i) => (
          <div key={i} className="flex items-center gap-2">
            <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold
              ${i < step ? 'bg-green-500 text-white' : i === step ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-500'}`}>
              {i < step ? '✓' : i + 1}
            </div>
            <span className={`text-sm hidden sm:block ${i === step ? 'font-semibold text-blue-700' : 'text-gray-400'}`}>{s}</span>
            {i < STEPS.length - 1 && <div className="w-8 h-px bg-gray-300 mx-1" />}
          </div>
        ))}
      </div>

      {/* Erro global */}
      {erro && (
        <div className="bg-red-50 border border-red-200 text-red-700 rounded-lg p-4 mb-4 text-sm">
          {erro}
        </div>
      )}

      {/* ── PASSO 0: Conexão ── */}
      {step === 0 && (
        <div className="bg-white rounded-xl border border-gray-200 p-6 max-w-md">
          <h2 className="font-semibold text-gray-700 mb-4">Credenciais do sistema antigo</h2>
          <div className="space-y-4">
            <div>
              <label className="block text-sm text-gray-600 mb-1">E-mail</label>
              <input className="input-rematei" type="email" value={creds.email}
                onChange={e => setCreds(c => ({ ...c, email: e.target.value }))}
                placeholder="email@exemplo.com" />
            </div>
            <div>
              <label className="block text-sm text-gray-600 mb-1">Senha</label>
              <input className="input-rematei" type="password" value={creds.password}
                onChange={e => setCreds(c => ({ ...c, password: e.target.value }))}
                placeholder="••••••••" />
            </div>
            <button onClick={handleBuscarLeiloes} disabled={loading || !creds.email || !creds.password}
              className="btn-rematei w-full">
              {loading ? 'Conectando...' : 'Buscar Leilões →'}
            </button>
          </div>
        </div>
      )}

      {/* ── PASSO 1: Selecionar Leilão ── */}
      {step === 1 && (
        <div className="bg-white rounded-xl border border-gray-200 p-6">
          <h2 className="font-semibold text-gray-700 mb-4">Selecione o leilão para importar</h2>
          {loading && <p className="text-blue-600 text-sm mb-4">⏳ Buscando lotes... pode demorar 1-2 min</p>}
          <div className="space-y-2">
            {leiloes.map(l => {
              const reg = historico.find(h => String(h.leilao_id_antigo) === String(l.id))
              return (
                <button key={l.id} onClick={() => handlePreview(l)} disabled={loading}
                  className={`w-full text-left p-4 rounded-lg border transition flex items-center justify-between gap-3
                    ${reg
                      ? 'border-green-300 bg-green-50 hover:border-green-400'
                      : 'border-gray-200 hover:border-blue-400 hover:bg-blue-50'}`}>
                  <div>
                    <span className="font-medium text-gray-800">{l.nome}</span>
                    <span className="text-xs text-gray-400 ml-2">id: {l.id}</span>
                  </div>
                  {reg && (
                    <div className="text-right shrink-0 space-y-1">
                      <div className="flex items-center gap-2 justify-end">
                        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-green-100 text-green-700 text-xs font-medium">
                          ✓ Importado
                        </span>
                        <button
                          onClick={e => { e.stopPropagation(); handleMigrarDespesas(reg) }}
                          disabled={migrandoDespesas[reg.leilao_id_antigo] === 'loading'}
                          title="Migrar despesas dos lotes já importados"
                          className="px-2 py-0.5 rounded bg-amber-100 text-amber-700 text-xs font-medium hover:bg-amber-200 disabled:opacity-50 whitespace-nowrap">
                          {migrandoDespesas[reg.leilao_id_antigo] === 'loading' ? '⏳...' : '↻ Despesas'}
                        </button>
                      </div>
                      <div className="text-xs text-gray-400">
                        {reg.org_name} · {reg.importados} lotes · {new Date(reg.criado_em).toLocaleDateString('pt-BR')}
                      </div>
                      {migrandoDespesas[reg.leilao_id_antigo] && migrandoDespesas[reg.leilao_id_antigo] !== 'loading' && (() => {
                        const md = migrandoDespesas[reg.leilao_id_antigo]
                        if (md.erro) return (
                          <div className="text-xs rounded px-2 py-1 text-left bg-red-50 text-red-700">
                            Erro: {md.erro}
                          </div>
                        )
                        return (
                          <div className="text-xs rounded px-2 py-1 text-left bg-green-50 text-green-700 space-y-0.5">
                            <div>✓ {md.atualizados} lotes com despesas migradas · {md.sem_despesas} sem despesas no sistema antigo</div>
                            {md.nao_encontrados?.length > 0 && (
                              <div className="text-amber-700">⚠ {md.nao_encontrados.length} não encontrados no novo: {md.nao_encontrados.join(', ')}</div>
                            )}
                            {md.sem_despesas_lotes?.length > 0 && (
                              <div className="text-gray-500">Sem despesas scraped: {md.sem_despesas_lotes.join(', ')}</div>
                            )}
                            {md.erros?.length > 0 && (
                              <div className="text-red-600">Erros importador: {md.erros.join(' · ')}</div>
                            )}
                            {md.erros_scraper?.length > 0 && (
                              <div className="text-red-500">Erros scraper: {md.erros_scraper.join(' · ')}</div>
                            )}
                          </div>
                        )
                      })()}
                    </div>
                  )}
                </button>
              )
            })}
          </div>
          <button onClick={() => setStep(0)} className="mt-4 text-sm text-gray-500 hover:underline">← Voltar</button>
        </div>
      )}

      {/* ── PASSO 2: Revisar Lotes ── */}
      {step === 2 && preview && (
        <div className="bg-white rounded-xl border border-gray-200 p-6">

          {/* Resumo do leilão do sistema antigo */}
          <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-5 text-sm">
            <p className="font-semibold text-gray-700 mb-2">Dados do leilão no sistema antigo</p>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 text-xs">
              <div>
                <span className="text-gray-400 block">Data</span>
                <span className="font-medium text-gray-700">
                  {preview.data_leilao
                    ? new Date(preview.data_leilao + 'T12:00:00').toLocaleDateString('pt-BR')
                    : '—'}
                </span>
              </div>
              <div>
                <span className="text-gray-400 block">Leiloeiro</span>
                <span className="font-medium text-gray-700">{preview.nome_leiloeiro || '—'}</span>
              </div>
              <div>
                <span className="text-gray-400 block">Comissão Venda</span>
                <span className="font-medium text-blue-700">{preview.comissao_venda ?? '—'}%</span>
              </div>
              <div>
                <span className="text-gray-400 block">Comissão Compra</span>
                <span className="font-medium text-purple-700">{preview.comissao_compra ?? '—'}%</span>
              </div>
              {preview.comissao_defesa > 0 && (
                <div>
                  <span className="text-gray-400 block">Comissão Defesa</span>
                  <span className="font-medium text-orange-600">{preview.comissao_defesa}%</span>
                </div>
              )}
              {preview.tipo_faturamento && (
                <div>
                  <span className="text-gray-400 block">Faturamento</span>
                  <span className="font-medium text-gray-700">{preview.tipo_faturamento}</span>
                </div>
              )}
            </div>
          </div>

          <div className="flex flex-wrap gap-4 mb-6">
            <div className="bg-blue-50 rounded-lg p-4 flex-1 min-w-[140px]">
              <div className="text-2xl font-bold text-blue-700">{preview.total_faturado}</div>
              <div className="text-xs text-gray-500">Lotes FATURADO</div>
            </div>
            <div className="bg-orange-50 rounded-lg p-4 flex-1 min-w-[140px]">
              <div className="text-2xl font-bold text-orange-600">{preview.total_defesa}</div>
              <div className="text-xs text-gray-500">Lotes DEFESA</div>
            </div>
            <div className="bg-gray-50 rounded-lg p-4 flex-1 min-w-[160px]">
              <div className="text-sm font-semibold text-gray-700 mb-1">Comissões únicas nos lotes</div>
              {Object.entries(preview.combinacoes_comissao).map(([k, n]) => (
                <div key={k} className="text-xs text-gray-600">{k} → {n} lotes</div>
              ))}
            </div>
          </div>

          {preview.erros?.length > 0 && (
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mb-4 text-xs text-yellow-800">
              <strong>Avisos:</strong> {preview.erros.join(' | ')}
            </div>
          )}

          <div className="overflow-x-auto">
            <table className="w-full text-xs border-collapse">
              <thead>
                <tr className="bg-gray-50 border-b">
                  {['Lote','Status','Vendedor','Comprador','Tipo / Raça / Idade','Sexo','Qtd','Valor Unit','Valor Total','V%','C%','Despesas','Vencimento'].map(h => (
                    <th key={h} className="px-2 py-2 text-left text-gray-600 font-medium whitespace-nowrap">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {preview.lotes.map((l, i) => {
                  const venc = l.parcelas?.[0]?.data_vencimento || '-'
                  return (
                    <tr key={i} className={`border-b ${l.status === 'DEFESA' ? 'bg-orange-50' : 'hover:bg-gray-50'}`}>
                      <td className="px-2 py-1.5 font-mono font-bold">{l.numero_lote}</td>
                      <td className="px-2 py-1.5">
                        <span className={`px-1.5 py-0.5 rounded text-xs font-medium ${l.status === 'DEFESA' ? 'bg-orange-100 text-orange-700' : 'bg-green-100 text-green-700'}`}>
                          {l.status}
                        </span>
                      </td>
                      <td className="px-2 py-1.5 max-w-[140px] truncate" title={l.vendedor_nome}>{l.vendedor_nome}</td>
                      <td className="px-2 py-1.5 max-w-[140px] truncate" title={l.comprador_nome}>{l.comprador_nome}</td>
                      <td className="px-2 py-1.5 text-gray-600 whitespace-nowrap">{l.tipo_animal} · {l.raca} · {l.idade}</td>
                      <td className="px-2 py-1.5">{l.sexo}</td>
                      <td className="px-2 py-1.5 text-right">{l.qtd}</td>
                      <td className="px-2 py-1.5 text-right">R$ {brl(l.valor_unitario)}</td>
                      <td className="px-2 py-1.5 text-right font-medium">R$ {brl(l.valor_total)}</td>
                      <td className="px-2 py-1.5 text-center text-blue-700">{l.comissao_venda_pct}%</td>
                      <td className="px-2 py-1.5 text-center text-purple-700">{l.comissao_compra_pct}%</td>
                      <td className="px-2 py-1.5 text-center">
                        {l.despesas?.length > 0
                          ? <span className="px-1.5 py-0.5 rounded bg-amber-100 text-amber-700 text-xs font-medium"
                              title={l.despesas.map(d => `${d.titulo}: R$${brl(d.valor)}`).join('\n')}>
                              {l.despesas.length}
                            </span>
                          : <span className="text-gray-300">—</span>
                        }
                      </td>
                      <td className="px-2 py-1.5 text-gray-500 whitespace-nowrap">{venc}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>

          <div className="flex gap-3 mt-6">
            <button onClick={() => setStep(1)} className="px-4 py-2 border border-gray-300 rounded-lg text-sm text-gray-600 hover:bg-gray-50">
              ← Voltar
            </button>
            <button onClick={handleAvancarDestino} disabled={loading}
              className="px-6 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 disabled:opacity-50">
              {loading ? 'Carregando...' : 'Aprovado — Configurar Destino →'}
            </button>
          </div>
        </div>
      )}

      {/* ── PASSO 3: Configurar e Executar ── */}
      {step === 3 && (
        <div className="bg-white rounded-xl border border-gray-200 p-6">
          <h2 className="font-semibold text-gray-700 mb-1">Configurar destino</h2>
          <p className="text-xs text-gray-400 mb-6">Leilão de origem: <strong>{leilaoSelecionado?.nome}</strong></p>

          {/* 1. Selecionar Organizador */}
          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-2">Organizador destino</label>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 max-h-48 overflow-y-auto pr-1">
              {organizadores.map(org => (
                <button key={org.id}
                  onClick={() => handleSelecionarOrg(org)}
                  className={`text-left p-3 rounded-lg border transition text-sm ${
                    orgSelecionada?.id === org.id
                      ? 'border-blue-500 bg-blue-50 text-blue-800'
                      : 'border-gray-200 hover:border-blue-300 hover:bg-gray-50 text-gray-700'
                  }`}>
                  <div className="font-medium">{org.name}</div>
                  {org.fluxo_leilao && (
                    <div className="text-xs text-gray-400 mt-0.5">{FLUXO_LABEL[org.fluxo_leilao] || org.fluxo_leilao}</div>
                  )}
                </button>
              ))}
            </div>
          </div>

          {/* 2. Fluxo e Comissão (ao selecionar org) */}
          {orgSelecionada && (
            <div className="border-t border-gray-100 pt-5 mb-5 space-y-4">
              {loadingOrg && <p className="text-sm text-blue-600">Carregando comissões...</p>}

              <div className="flex gap-4">
                <div className="flex-1">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Fluxo de comissão</label>
                  <select className="input-rematei" value={fluxo} onChange={e => setFluxo(e.target.value)}>
                    <option value="">Selecione...</option>
                    {FLUXO_OPTIONS.map(o => (
                      <option key={o.value} value={o.value}>{o.label}</option>
                    ))}
                  </select>
                </div>
                <div className="flex-1">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Comissão padrão</label>
                  <select className="input-rematei" value={comissaoPadraoId} onChange={e => setComissaoPadraoId(e.target.value)}>
                    <option value="">Sem padrão</option>
                    {comissoes.map(c => (
                      <option key={c.id} value={c.id}>
                        {c.nome} — V:{c.comissao_venda}% C:{c.comissao_compra}%{c.is_padrao ? ' ★' : ''}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* 3. Leiloeiro */}
              <div className="bg-gray-50 rounded-lg p-4">
                <p className="text-sm font-medium text-gray-700 mb-1">
                  Leiloeiro
                  {preview?.nome_leiloeiro && (
                    <span className="text-xs text-gray-400 font-normal ml-2">
                      (sistema antigo: <strong>{preview.nome_leiloeiro}</strong>)
                    </span>
                  )}
                </p>

                {leiloeiros.length > 0 && (
                  <select className="input-rematei mb-2" value={leiloeiroId}
                    onChange={e => setLeiloeiroId(e.target.value)}>
                    <option value="">— Sem leiloeiro / criar novo —</option>
                    {leiloeiros.map(l => (
                      <option key={l.id} value={l.id}>{l.nome}</option>
                    ))}
                  </select>
                )}

                {!leiloeiroId && (
                  <div className="flex gap-2 items-end">
                    <div className="flex-1">
                      <label className="block text-xs text-gray-500 mb-1">Nome do novo leiloeiro</label>
                      <input className="input-rematei" value={novoLeiloeiroNome}
                        onChange={e => setNovoLeiloeiroNome(e.target.value)}
                        placeholder="Nome completo" />
                    </div>
                    <button onClick={handleCriarLeiloeiro}
                      disabled={loadingLeiloeiro || !novoLeiloeiroNome.trim()}
                      className="px-3 py-2 bg-gray-700 text-white rounded-lg text-sm hover:bg-gray-800 disabled:opacity-50 whitespace-nowrap">
                      {loadingLeiloeiro ? '...' : '+ Criar'}
                    </button>
                  </div>
                )}

                {leiloeiroCriado && (
                  <p className="text-xs text-green-700 mt-1">✓ Leiloeiro criado e selecionado</p>
                )}
              </div>

              {/* 4. Leilão destino */}
              <div className="bg-blue-50 rounded-lg p-4">
                <div className="flex items-center justify-between mb-3">
                  <p className="text-sm font-medium text-blue-800">Leilão destino</p>
                  <div className="flex gap-1 text-xs">
                    <button onClick={() => { setModoLeilao('selecionar'); setLeilaoCriado(null); setLeilaoIdNovo('') }}
                      className={`px-3 py-1 rounded-lg border transition ${modoLeilao === 'selecionar' ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-gray-600 border-gray-300 hover:bg-gray-50'}`}>
                      Selecionar existente
                    </button>
                    <button onClick={() => { setModoLeilao('criar'); setLeilaoCriado(null); setLeilaoIdNovo('') }}
                      className={`px-3 py-1 rounded-lg border transition ${modoLeilao === 'criar' ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-gray-600 border-gray-300 hover:bg-gray-50'}`}>
                      + Criar novo
                    </button>
                  </div>
                </div>

                {modoLeilao === 'selecionar' && (
                  leilioesDaOrg.length === 0 ? (
                    <p className="text-xs text-gray-500">Nenhum leilão encontrado.
                      <button onClick={() => setModoLeilao('criar')} className="ml-1 text-blue-600 underline">Criar novo</button>
                    </p>
                  ) : (
                    <select className="input-rematei" value={leilaoIdNovo}
                      onChange={e => setLeilaoIdNovo(e.target.value)}>
                      <option value="">— Selecione um leilão —</option>
                      {leilioesDaOrg.map(l => (
                        <option key={l.id} value={l.id}>
                          {l.nome} — {l.data_leilao ? new Date(l.data_leilao).toLocaleDateString('pt-BR') : ''} (id: {l.id})
                        </option>
                      ))}
                    </select>
                  )
                )}

                {modoLeilao === 'criar' && (
                  leilaoCriado ? (
                    <div className="flex items-center gap-2 text-sm text-green-700 bg-green-50 border border-green-200 rounded-lg px-3 py-2">
                      <span>✓ Criado:</span>
                      <strong>{leilaoCriado.nome}</strong>
                      <span className="text-green-500 text-xs">(id: {leilaoCriado.id})</span>
                    </div>
                  ) : (
                    <>
                      <div className="flex gap-3 mb-2">
                        <div className="flex-1">
                          <label className="block text-xs text-gray-600 mb-1">Nome</label>
                          <input className="input-rematei" value={novoNome}
                            onChange={e => setNovoNome(e.target.value)} placeholder="Nome do leilão" />
                        </div>
                      </div>
                      <div className="flex gap-3 mb-2">
                        <div className="w-40">
                          <label className="block text-xs text-gray-600 mb-1">Data</label>
                          <input className="input-rematei" type="date" value={novoData}
                            onChange={e => setNovoData(e.target.value)} />
                        </div>
                        <div className="w-28">
                          <label className="block text-xs text-gray-600 mb-1">Hora início</label>
                          <input className="input-rematei" type="time" value={novoHora}
                            onChange={e => setNovoHora(e.target.value)} />
                        </div>
                      </div>
                      <div className="flex gap-3 mb-3">
                        <div className="flex-1">
                          <label className="block text-xs text-gray-600 mb-1">Cidade</label>
                          <input className="input-rematei" value={novoCidade}
                            onChange={e => setNovoCidade(e.target.value)} placeholder="Ex: Uberlândia" />
                        </div>
                        <div className="w-20">
                          <label className="block text-xs text-gray-600 mb-1">UF</label>
                          <input className="input-rematei uppercase" value={novoUf} maxLength={2}
                            onChange={e => setNovoUf(e.target.value.toUpperCase())} placeholder="MG" />
                        </div>
                      </div>
                      <button onClick={handleCriarLeilao}
                        disabled={loadingCriar || !novoNome || !novoData || !fluxo}
                        className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 disabled:opacity-50">
                        {loadingCriar ? 'Criando...' : '+ Criar Leilão'}
                      </button>
                    </>
                  )
                )}
              </div>
            </div>
          )}

          {/* Progresso do job em background */}
          {loading && !dryRun && jobId && (
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4 text-sm">
              <div className="flex items-center gap-3 mb-2">
                <svg className="animate-spin h-5 w-5 text-blue-600" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"/>
                </svg>
                <span className="font-medium text-blue-800">
                  {jobFaseLabel || 'Processando...'}
                </span>
              </div>
              <div className="flex gap-2 mt-1">
                {['iniciando','scraping','importando'].map(f => (
                  <span key={f} className={`px-2 py-0.5 rounded-full text-xs font-medium transition-all
                    ${jobFase === f ? 'bg-blue-600 text-white' :
                      ['iniciando','scraping','importando'].indexOf(jobFase) > ['iniciando','scraping','importando'].indexOf(f)
                        ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-400'}`}>
                    {f === 'iniciando' ? '1. Iniciando' : f === 'scraping' ? '2. Raspando lotes' : '3. Importando'}
                  </span>
                ))}
              </div>
              <p className="text-xs text-blue-500 mt-2">Pode aguardar — o processo continua mesmo se fechar a tela</p>
            </div>
          )}

          {/* Resultado */}
          {resultado && (
            <div className={`rounded-lg p-4 text-sm mb-4 ${resultado.erros?.length ? 'bg-yellow-50 border border-yellow-200' : 'bg-green-50 border border-green-200'}`}>
              <div className="font-semibold mb-2">
                {dryRun ? '🔍 Resultado Dry-Run' : '✅ Importação Concluída'}
              </div>
              <div className="text-gray-700">Importados: <strong>{resultado.importados}</strong></div>
              {resultado.erros?.length > 0 && (
                <div className="mt-2">
                  <div className="font-medium text-yellow-800">Erros/Avisos:</div>
                  {resultado.erros.map((e, i) => <div key={i} className="text-yellow-700 text-xs mt-0.5">• {e}</div>)}
                </div>
              )}
            </div>
          )}

          {/* Clientes faltantes */}
          {clientesFaltantes.length > 0 && (
            <div className="bg-orange-50 border border-orange-200 rounded-lg p-4">
              <div className="flex items-center justify-between mb-3">
                <p className="text-sm font-semibold text-orange-800">
                  Clientes não encontrados ({clientesFaltantes.length})
                </p>
                <button onClick={handleCriarTodosClientes}
                  disabled={clientesFaltantes.every(n => clientesCriando[n] === 'ok')}
                  className="px-3 py-1 text-xs bg-orange-600 text-white rounded-lg hover:bg-orange-700 disabled:opacity-40">
                  Criar todos
                </button>
              </div>
              <div className="space-y-2">
                {clientesFaltantes.map(nome => {
                  const st = clientesCriando[nome]
                  return (
                    <div key={nome} className="flex items-center justify-between gap-3 bg-white rounded-lg px-3 py-2 border border-orange-100">
                      <span className="text-sm text-gray-700 flex-1">{nome}</span>
                      {st === 'ok' ? (
                        <span className="text-xs text-green-600 font-medium">✓ Criado</span>
                      ) : st === 'erro' ? (
                        <span className="text-xs text-red-600">Erro</span>
                      ) : (
                        <button onClick={() => handleCriarCliente(nome)}
                          disabled={st === 'loading'}
                          className="px-3 py-1 text-xs bg-white border border-orange-300 text-orange-700 rounded-lg hover:bg-orange-50 disabled:opacity-50">
                          {st === 'loading' ? '...' : '+ Criar'}
                        </button>
                      )}
                    </div>
                  )
                })}
              </div>
              {clientesFaltantes.every(n => clientesCriando[n] === 'ok') && (
                <p className="text-xs text-green-700 mt-3">
                  ✓ Todos criados — rode o dry-run novamente para validar
                </p>
              )}
            </div>
          )}

          {/* Botões de ação */}
          <div className="border-t border-gray-100 pt-4 space-y-3">
            <div className="flex gap-3">
              <button onClick={() => setStep(2)} className="px-4 py-2 border border-gray-300 rounded-lg text-sm text-gray-600 hover:bg-gray-50">
                ← Revisar Lotes
              </button>
              <button onClick={() => handleExecutar(true)}
                disabled={loading || !orgSelecionada || !leilaoIdNovo}
                className="flex-1 py-2 rounded-lg text-sm font-medium text-white bg-gray-500 hover:bg-gray-600 disabled:opacity-50">
                {loading && dryRun ? 'Validando...' : '🔍 Validar (Dry-Run)'}
              </button>
              <button onClick={() => handleExecutar(false)}
                disabled={loading || !orgSelecionada || !leilaoIdNovo}
                className="flex-1 py-2 rounded-lg text-sm font-medium text-white bg-green-600 hover:bg-green-700 disabled:opacity-50">
                {loading && !dryRun
                  ? (jobFase === 'scraping' ? '⏳ Raspando lotes...' : jobFase === 'importando' ? '⏳ Importando...' : '⏳ Aguarde...')
                  : '🚀 Importar'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
